(() => {
  const q = (selector, context = document) => context.querySelector(selector);
  const qa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 960px)');

  const cursor = q('[data-wr-cursor]');
  if (cursor && finePointer.matches) {
    let pointerX = innerWidth / 2;
    let pointerY = innerHeight / 2;
    let cursorX = pointerX;
    let cursorY = pointerY;
    let cursorFrame = 0;

    document.documentElement.classList.add('wr-cursor-ready');

    const drawCursor = () => {
      if (reduced) {
        cursorX = pointerX;
        cursorY = pointerY;
      } else {
        cursorX += (pointerX - cursorX) * .32;
        cursorY += (pointerY - cursorY) * .32;
      }
      cursor.style.left = cursorX + 'px';
      cursor.style.top = cursorY + 'px';
      if (Math.abs(pointerX - cursorX) > .2 || Math.abs(pointerY - cursorY) > .2) cursorFrame = requestAnimationFrame(drawCursor);
      else cursorFrame = 0;
    };

    const setCursorState = (target) => {
      const zoomTarget = target.closest('.wr-product__gallery[data-product-zoom="true"]');
      const productTarget = target.closest('[data-cursor-product]');
      const linkTarget = target.closest('a,button,input,select,label,[role="button"]');
      cursor.classList.toggle('is-zoom', Boolean(zoomTarget));
      cursor.classList.toggle('is-product', !zoomTarget && Boolean(productTarget));
      cursor.classList.toggle('is-link', !zoomTarget && !productTarget && Boolean(linkTarget));
    };

    document.addEventListener('pointermove', (event) => {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      pointerX = event.clientX;
      pointerY = event.clientY;
      cursor.classList.add('is-visible');
      setCursorState(event.target);
      if (!cursorFrame) cursorFrame = requestAnimationFrame(drawCursor);
    }, { passive: true });

    document.addEventListener('pointerdown', () => cursor.classList.add('is-pressed'), { passive: true });
    document.addEventListener('pointerup', () => cursor.classList.remove('is-pressed'), { passive: true });
    document.addEventListener('pointerleave', () => cursor.classList.remove('is-visible'), { passive: true });
    window.addEventListener('blur', () => cursor.classList.remove('is-visible'));
  }

  qa('[data-product-gallery][data-product-zoom="true"]').forEach((gallery) => {
    const productSection = gallery.closest('.wr-product');
    const dialog = q('[data-product-zoom-dialog]', productSection);
    if (!dialog) return;
    const galleryImages = qa('img', gallery);
    const dialogImage = q('[data-product-zoom-image]', dialog);
    const counter = q('[data-product-zoom-counter]', dialog);
    const openButton = q('[data-product-zoom-open]', gallery);
    const closeButton = q('[data-product-zoom-close]', dialog);
    const previousButton = q('[data-product-zoom-previous]', dialog);
    const nextButton = q('[data-product-zoom-next]', dialog);
    let activeIndex = 0;
    let previousFocus = null;

    const largeSource = (image) => {
      const source = image.currentSrc || image.src;
      try {
        const url = new URL(source, location.href);
        if (url.hostname.includes('shopify') || url.pathname.includes('/cdn/shop/')) url.searchParams.set('width', '2800');
        return url.href;
      } catch (error) {
        return source;
      }
    };

    const showImage = (index, animate = true) => {
      if (!galleryImages.length) return;
      activeIndex = (index + galleryImages.length) % galleryImages.length;
      const sourceImage = galleryImages[activeIndex];
      if (animate && !reduced) dialogImage.classList.add('is-changing');
      const update = () => {
        dialogImage.src = largeSource(sourceImage);
        dialogImage.alt = sourceImage.alt || '';
        if (counter) counter.textContent = (activeIndex + 1) + ' / ' + galleryImages.length;
        requestAnimationFrame(() => dialogImage.classList.remove('is-changing'));
      };
      if (animate && !reduced) window.setTimeout(update, 130);
      else update();
    };

    const openZoom = (index) => {
      previousFocus = document.activeElement;
      showImage(index, false);
      dialog.classList.add('is-open');
      dialog.setAttribute('aria-hidden', 'false');
      document.body.classList.add('wr-media-zoom-open');
      window.setTimeout(() => closeButton?.focus({ preventScroll: true }), reduced ? 0 : 420);
    };

    const closeZoom = () => {
      dialog.classList.remove('is-open');
      dialog.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('wr-media-zoom-open');
      previousFocus?.focus?.({ preventScroll: true });
    };

    openButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openZoom(Number(gallery.dataset.galleryIndex || 0));
    }, true);

    gallery.addEventListener('click', (event) => {
      if (!finePointer.matches || event.target.closest('[data-product-zoom-open]')) return;
      const image = event.target.closest('img');
      if (!image) return;
      const index = galleryImages.indexOf(image);
      if (index >= 0) openZoom(index);
    });

    closeButton?.addEventListener('click', closeZoom);
    previousButton?.addEventListener('click', () => showImage(activeIndex - 1));
    nextButton?.addEventListener('click', () => showImage(activeIndex + 1));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) closeZoom(); });

    dialog.addEventListener('touchstart', (event) => {
      dialog.dataset.touchX = String(event.changedTouches[0].clientX);
    }, { passive: true });
    dialog.addEventListener('touchend', (event) => {
      const startX = Number(dialog.dataset.touchX || event.changedTouches[0].clientX);
      const distance = event.changedTouches[0].clientX - startX;
      if (Math.abs(distance) > 48) showImage(activeIndex + (distance < 0 ? 1 : -1));
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (!dialog.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeZoom();
      if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showImage(activeIndex + 1);
    });
  });

  qa('[data-collection-sort]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));
})();
